import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faList, faClock, faUsers, faStar, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { faYoutube, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './FreeCourses.css'; // Assuming you have a CSS file for styling

const FreeCourses = () => {
  const playlists = [
    {
      id: 'admin-course',
      title: 'Salesforce Admin Complete Course',
      description: 'Master Salesforce administration from basics to advanced concepts',
      thumbnail: 'https://img.youtube.com/vi/_wCemxZrcLA/maxresdefault.jpg',
      playlistUrl: 'https://www.youtube.com/playlist?list=PLNBZoUInTXzXtFnC9nh0a-YGBrTD8HnES',
      videoCount: 24,
      duration: '15+ hours',
      level: 'Beginner to Advanced'
    },
    {
      id: 'dev-course',
      title: 'Salesforce Developer Bootcamp',
      description: 'Learn Apex, Visualforce, LWC and integration patterns',
      thumbnail: 'https://img.youtube.com/vi/YfzKOCaLN_A/maxresdefault.jpg',
      playlistUrl: 'https://www.youtube.com/playlist?list=PLNBZoUInTXzXjk5oY4uX3fxA0-zS3OQE8',
      videoCount: 18,
      duration: '12+ hours',
      level: 'Intermediate'
    },
    {
      id: 'js-course',
      title: 'JavaScript for Salesforce',
      description: 'Essential JavaScript concepts for Salesforce developers',
      thumbnail: 'https://img.youtube.com/vi/c_ZoVJe76lE/maxresdefault.jpg',
      playlistUrl: 'https://www.youtube.com/playlist?list=PLNBZoUInTXzVIWcNrulgtk2ONMYRaSabF',
      videoCount: 10,
      duration: '6+ hours',
      level: 'Beginner'
    },
    {
      id: 'lwc-course',
      title: 'LWC Masterclass',
      description: 'Build modern UI with Lightning Web Components',
      thumbnail: 'https://img.youtube.com/vi/0hPOjNoflFg/maxresdefault.jpg',
      playlistUrl: 'https://www.youtube.com/playlist?list=PLNBZoUInTXzXmB9GnOkWLoBHH4ZiS1exh',
      videoCount: 15,
      duration: '9+ hours',
      level: 'Intermediate'
    }
  ];

  const popularVideos = [
    {
      id: 'kcademy1',
      title: 'Salesforce KCademy: Class 1',
      description: 'Get started with Salesforce CRM basics',
      thumbnail: 'https://img.youtube.com/vi/0jH3nauft64/maxresdefault.jpg',
      videoUrl: 'https://youtu.be/0jH3nauft64',
      duration: '1h 24m',
      views: '5.2K'
    },
    {
      id: 'future',
      title: 'Know Your Future with Salesforce',
      description: 'Career opportunities in Salesforce ecosystem',
      thumbnail: 'https://img.youtube.com/vi/lQSKbR3ggVk/maxresdefault.jpg',
      videoUrl: 'https://youtu.be/lQSKbR3ggVk',
      duration: '45m',
      views: '3.8K'
    },
    {
      id: 'admin-prep',
      title: 'Admin Exam Prep - Class 1',
      description: 'Start your certification journey',
      thumbnail: 'https://img.youtube.com/vi/-Zd0WQ8FctY/maxresdefault.jpg',
      videoUrl: 'https://youtu.be/-Zd0WQ8FctY',
      duration: '1h 12m',
      views: '4.5K'
    },
    {
      id: 'soql-telugu',
      title: 'SOQL Basics in Telugu',
      description: 'Learn SOQL in Telugu with examples',
      thumbnail: 'https://img.youtube.com/vi/f6DqA38MAto/maxresdefault.jpg',
      videoUrl: 'https://youtu.be/f6DqA38MAto',
      duration: '38m',
      views: '2.7K'
    }
  ];

  return (
    <div className="free-courses-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <h1>Free Salesforce Learning Resources</h1>
          <p>Learn Salesforce with our comprehensive free courses and tutorials</p>
          <div className="stats">
            <div className="stat">
              <FontAwesomeIcon icon={faPlay} />
              <span>50+ Free Videos</span>
            </div>
            <div className="stat">
              <FontAwesomeIcon icon={faList} />
              <span>10+ Playlists</span>
            </div>
            <div className="stat">
              <FontAwesomeIcon icon={faUsers} />
              <span>15K+ Students</span>
            </div>
          </div>
        </div>
      </section>

      {/* Playlists Section */}
      <section className="playlists-section">
        <div className="container">
          <h2>
            <FontAwesomeIcon icon={faList} />
            Featured Playlists
          </h2>
          <p>Structured learning paths for comprehensive understanding</p>
          
          <div className="course-grid">
            {playlists.map(playlist => (
              <div className="course-card" key={playlist.id}>
                <div className="thumbnail-container">
                  <img src={playlist.thumbnail} alt={playlist.title} className="course-thumbnail" />
                  <div className="playlist-badge">
                    <FontAwesomeIcon icon={faList} /> Playlist
                  </div>
                </div>
                <div className="course-content">
                  <h3>{playlist.title}</h3>
                  <p className="course-description">{playlist.description}</p>
                  <div className="course-meta">
                    <span><FontAwesomeIcon icon={faPlay} /> {playlist.videoCount} videos</span>
                    <span><FontAwesomeIcon icon={faClock} /> {playlist.duration}</span>
                    <span><FontAwesomeIcon icon={faStar} /> {playlist.level}</span>
                  </div>
                </div>
                <div className="course-actions">
                  <a href={playlist.playlistUrl} target="_blank" rel="noopener noreferrer" className="btn youtube-btn">
                    <FontAwesomeIcon icon={faYoutube} /> View Playlist
                  </a>
                  <a href={`https://wa.me/919441222237?text=I'm interested in ${playlist.title} playlist`} target="_blank" rel="noopener noreferrer" className="btn whatsapp-btn">
                    <FontAwesomeIcon icon={faWhatsapp} /> Get Help
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Popular Videos Section */}
      <section className="videos-section">
        <div className="container">
          <h2>
            <FontAwesomeIcon icon={faPlay} />
            Popular Free Videos
          </h2>
          <p>Hand-picked individual videos to get you started</p>
          
          <div className="course-grid">
            {popularVideos.map(video => (
              <div className="course-card" key={video.id}>
                <div className="thumbnail-container">
                  <img src={video.thumbnail} alt={video.title} className="course-thumbnail" />
                  <div className="duration-badge">
                    <FontAwesomeIcon icon={faClock} /> {video.duration}
                  </div>
                </div>
                <div className="course-content">
                  <h3>{video.title}</h3>
                  <p className="course-description">{video.description}</p>
                  <div className="course-meta">
                    <span><FontAwesomeIcon icon={faUsers} /> {video.views} views</span>
                    <span><FontAwesomeIcon icon={faCheckCircle} /> Free Forever</span>
                  </div>
                </div>
                <div className="course-actions">
                  <a href={video.videoUrl} target="_blank" rel="noopener noreferrer" className="btn youtube-btn">
                    <FontAwesomeIcon icon={faYoutube} /> Watch Now
                  </a>
                  <a href={`https://wa.me/919441222237?text=I have a question about ${video.title} video`} target="_blank" rel="noopener noreferrer" className="btn whatsapp-btn">
                    <FontAwesomeIcon icon={faWhatsapp} /> Ask Question
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Want More Free Content?</h2>
          <p>Subscribe to our YouTube channel for weekly Salesforce tutorials</p>
          <a href="https://www.youtube.com/@codexlnc" target="_blank" rel="noopener noreferrer" className="subscribe-btn">
            <FontAwesomeIcon icon={faYoutube} /> Subscribe Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default FreeCourses;